import { Stack } from "@volca/ui/components/ui/stack";
import type { ApPurchaseOrderOption } from "@/accounts-payable/types";
import {
  purchaseOrderLabel,
  purchaseOrderOptionMeta,
} from "@/accounts-payable/utils";
import { PickerItem } from "./picker-command";

/**
 * One ServiceTitan PO in the manual PO picker: its number and the tags that
 * matter for the choice, then status, job, vendor, total and date, then the
 * references that tie it to a vendor document.
 */
export const PurchaseOrderOptionItem = ({
  option,
  selected,
  disabled,
  onSelect,
}: {
  option: ApPurchaseOrderOption;
  selected: boolean;
  disabled: boolean;
  onSelect: () => void;
}) => {
  const references = [
    option.vendor_document_number &&
      `Vendor invoice ${option.vendor_document_number}`,
    option.memo,
  ].filter(Boolean);

  return (
    <PickerItem
      value={String(option.st_purchase_order_id)}
      selected={selected}
      // ServiceTitan voided it; the server would refuse it.
      disabled={disabled || option.canceled}
      onSelect={onSelect}
    >
      <Stack align="start" gap={0} className="min-w-0 flex-1">
        <Stack direction="row" gap={2} align="baseline" className="flex-wrap">
          <span className="font-semibold">{purchaseOrderLabel(option)}</span>
          {option.current && (
            <span className="text-xs text-subtle">Current PO</span>
          )}
          {option.same_vendor && !option.current && (
            <span className="text-xs text-subtle">Same vendor</span>
          )}
          {/* Picking it moves the document, so say so before the click. */}
          {option.moves_job && (
            <span className="text-xs text-warning">
              Moves to another job or project
            </span>
          )}
        </Stack>
        <span className="text-xs text-subtle">
          {purchaseOrderOptionMeta(option).join(" · ")}
        </span>
        {references.length > 0 && (
          <span
            className="max-w-full truncate text-xs text-subtle"
            title={references.join(" · ")}
          >
            {references.join(" · ")}
          </span>
        )}
      </Stack>
    </PickerItem>
  );
};
